import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModulosComponent } from './modulos/modulos.component';
import { ModulosProfileComponent } from './modulos/modulos-profile/modulos-profile.component';
import { PerfilUsuarioComponent } from './modulos/perfil-usuario/perfil-usuario.component';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ComponentsModule } from "src/app/components/components.module";

@NgModule({
  declarations: [
    ModulosComponent,
    ModulosProfileComponent,
    PerfilUsuarioComponent
  ],
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    RouterModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatTooltipModule,
    ComponentsModule
]
})
export class MainModule { }
